import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { leftNaveRender } from "../Case";
import SideNavTop from "../SideNavTop";

const HrNav = ({ currentUser }) => {
  const [modulesArray, setModulesArray] = useState(
    leftNaveRender(localStorage.moduleType)
  );

  const showMenuOrNot = (module) => {
    setModulesArray(
      modulesArray.map((filterModule) => {
        filterModule.subModules.map((filter) => {
          if (filter.id === module.id) {
            filter.select = !module.select;
          } else {
            filter.select = false;
          }
          return filter;
        });
        return filterModule;
      })
    );
  };

  const showSubModulesList = (subModulesList) => {
    return subModulesList.map((subModule, subModuleIndex) => (
      <li key={subModuleIndex}>
        <Link to={subModule.link}>
          <i className={subModule.icons} />{" "}
          <span>{subModule.subModuleHeading} </span>
        </Link>
      </li>
    ));
  };

  const showSubModule = (subModules) => {
    return subModules.map((subModule, index) => (
      <li className="side-nav-item" key={index}>
        <Link
          to="#"
          className="side-nav-link"
          onClick={() => showMenuOrNot(subModule)}
        >
          <i className="dripicons-view-apps"></i>
          <span> {subModule.subModuleName} </span>
          <span className="menu-arrow"></span>
        </Link>
        {subModule.select ? (
          <ul className="side-nav-second-level" aria-expanded="false">
            {showSubModulesList(subModule.subModulesList)}
          </ul>
        ) : null}
      </li>
    ));
  };

  const showModules = modulesArray.map((module, index) => (
    <div key={index}>
      <li className="side-nav-title side-nav-item">
        {module.moduleName}
      </li>
      {showSubModule(module.subModules)}
      {/* <li className="side-nav-item">
        <Link
          to="#"
          className="side-nav-link"
          onClick={() => showMenuOrNot(module)}
        >
          <i className="dripicons-view-apps"></i>
          <span> {module.subModuleName} </span>
          <span className="menu-arrow"></span>
        </Link>
        {module.select ? (
          <ul className="side-nav-second-level" aria-expanded="false">
            {showSubModulesList(module.subModulesList)}
          </ul>
        ) : null}
      </li> */}
    </div>
  ));

  return (
    <ul className="metismenu side-nav">
      <li className="side-nav-item">
        <SideNavTop currentUser={currentUser} />
      </li>
      {showModules}
    </ul>
  );
};

HrNav.propTypes = {
  currentUser: PropTypes.object.isRequired
};

export default HrNav;
